import { render, staticRenderFns } from "./WelcomeFooter.vue?vue&type=template&id=22f0801d&"
import script from "./WelcomeFooter.vue?vue&type=script&lang=js&"
export * from "./WelcomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports